import { render, staticRenderFns } from "./kv-amount.vue?vue&type=template&id=4c591b3f&scoped=true"
import script from "./kv-amount.vue?vue&type=script&lang=js"
export * from "./kv-amount.vue?vue&type=script&lang=js"
import style0 from "./kv-amount.vue?vue&type=style&index=0&id=4c591b3f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c591b3f",
  null
  
)

export default component.exports